import CloseIcon from '@mui/icons-material/Close';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import InputBase from '@mui/material/InputBase';
import { styled } from '@mui/material/styles';
import { Spinner } from "native-base";
import { useState } from 'react';
import useStateRef from "react-usestateref";
import { LoadingView } from 'src/components/LoadingView';
import EventEmitter from 'src/utils/EventEmitter';
import { useMovementDetail, useAcceptMovement } from './api/fetchScripts';
import './styles/ProductPopup.css';

const TextFieldCustom = styled(InputBase)(() => ({
  '& .MuiInputBase-input': {
    borderRadius: 4,
    border: '1px solid #DADEE3',
    height: '36px',
    fontSize: 14,
    width: '100%',
    fontWeight: '400',
    padding: '0px 0px 0px 16px',
  },
  '& .MuiInputBase-input.Mui-disabled': {
    cursor: 'not-allowed',
    '-webkit-text-fill-color': '#000',
  },
}));

const AcknowledgeMovementPopup = (props) => {
  const orderData = props.customData.orderData
  const isReadOnly = orderData.status === 'Acknowledged'

  const { data: orderDetail, isLoading } = useMovementDetail(orderData.orderId)
  const acceptMovementMutation = useAcceptMovement()

  const [confirm, setConfirm, confirmRef] = useStateRef(false);
  const [name, setName] = useState(isReadOnly ? orderData.customerName : '');

  const onClosePopup = () => {
    EventEmitter.emit("show_custom_popup", { value: false });
  }

  const onClickSubmit = () => {
    acceptMovementMutation.mutate(
      {
        orderId: orderData.orderId,
        customerName: name,
      },
      {
        onSuccess: onClosePopup,
      }
    );
  };

  const handleNameChange = (event) => {
    setName(event.target.value)
  }

  const getDeliveryAddress = () => {
    var delivery_address = "";
    if (orderDetail) {
      delivery_address = orderDetail.transferToAddress;

      if (delivery_address) {
        delivery_address += ", " + orderDetail.transferToCity + ", " + orderDetail.transferToCounty + ", " + orderDetail.transferToPostCode;
      }
    }

    return delivery_address;
  }

  const isSubmitDisabled = isReadOnly ? false : !confirmRef.current || name === '' || acceptMovementMutation.isPending;

  return (
    <div className="custom-popup-container-wrapper" style={{ height: "100%" }}>
      <div>
        <div className="custom-popup-container-wrapper-header">
          <div>Acknowledge Movement</div>
          <div className="hide-mobile"><CloseIcon className="close-popup-icon" onClick={() => onClosePopup()} /></div>
        </div>
        {isLoading ?
          <LoadingView /> :
          <div className="custom-popup-container-wrapper-body">
            <div style={{ maxWidth: "719px", fontSize: "14px", color: "#333333" }}>By accepting this movement, you will be reporting to Cannatrek that you now hold the inventory outlined in the table below.</div>

            <div className="ack_movement_details" style={{ fontSize: "16px", marginTop: "15px", color: "#333333" }}>
              <div><span style={{ fontWeight: "600" }}>Movement Order:</span> {orderDetail.orderId}</div>
              <div style={{ marginTop: "10px" }}><span style={{ fontWeight: "600" }}>Receiving Location:</span> {getDeliveryAddress()}</div>
            </div>

            <div className="orders-content-table-container">
              <div className="orders-content-table">
                <div className="orders-table-header">
                  <div className="child" style={{ "--width": '80%', "cursor": 'auto' }}>
                    <div id="modal-modal-description" style={{ fontSize: "14px", marginBottom: '8px', fontWeight: '600' }}>Product Name</div>
                  </div>
                  <div className="child" style={{ "--width": '10%', "cursor": 'auto' }}>
                    <div id="modal-modal-description" style={{ fontSize: "14px", marginBottom: '8px', fontWeight: '600' }}>Units</div>
                  </div>
                </div>
                <div className="orders-table-body movement">
                  {orderDetail.lineItems.map((product, index) => (
                    <div key={`prod-${index}`} className="list" style={{ padding: "3px 0px" }}>
                      <div className="child" style={{ "--width": '80%' }}>
                        <div className="text">{product.description}</div>
                      </div>
                      <div className="child" style={{ "--width": '10%' }}>
                        <div className="text">+{product.quantity}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="custom-popup-container-wrapper-footer">
              <div id="modal-modal-description" style={{ fontSize: "14px", marginBottom: '8px', fontWeight: '600', color: '#09101D' }}>Your Full Name</div>
              <TextFieldCustom placeholder="Enter here" id="custom-input" fullWidth value={name} onChange={handleNameChange} disabled={isReadOnly}/>
              {isReadOnly && <p style={{ marginTop: '20px' }}>I confirm this movement order I am accepting is correct.</p>}
              {!isReadOnly && (
                <FormControlLabel style={{ marginLeft: '0px', paddingTop: '20px' }} control={
                <Checkbox sx={{ color: '#DF4C6F', '&.Mui-checked': { color: '#DF4C6F' }, '&.MuiCheckbox-root': { marginRight: '14px' } }} onChange={(e) => setConfirm(e.target.checked)} value={confirm} />}
                label="I confirm this movement order I am accepting is correct." />
              )}
            </div>
          </div>
        }
      </div>
      <div className="custom-popup-container-wrapper-bottom-orders">
        <span onClick={() => window.open(process.env.REACT_APP_CHATBOT)} className="popup-support-link hide-mobile-order" style={{ marginTop: '0px', cursor: "pointer" }}><HelpOutlineIcon style={{ marginRight: "5px", fontSize: "16px" }} />Support</span>
        <button className={`custom-popup-button-green ${isSubmitDisabled ? 'disabled' : ''}`} disabled={isSubmitDisabled} onClick={isReadOnly ? onClosePopup : onClickSubmit}>
          {isReadOnly ? 'Close' : acceptMovementMutation.isPending ? <Spinner color="white" /> : "Submit"}
        </button>
        <span onClick={() => window.open(process.env.REACT_APP_CHATBOT)} className="popup-support-link hide-desktop" style={{ cursor: "pointer", marginTop: '5px', justifyContent: 'center' }}><HelpOutlineIcon style={{ marginRight: "5px", fontSize: "16px" }} />Support</span>
      </div>
    </div >
  );
}

export default AcknowledgeMovementPopup;